import type { BriefSection } from '../../types/canvas';

interface ProgressDotsProps {
  sections: BriefSection[];
}

export function ProgressDots({ sections }: ProgressDotsProps) {
  return (
    <div className="flex gap-[3px]" aria-label={`${sections.filter((s) => s.status === 'approved').length} of ${sections.length} approved`}>
      {sections.map((section) => {
        let cls = 'w-[7px] h-[7px] rounded-full border-[1.5px] ';
        switch (section.status) {
          case 'approved':
            cls += 'bg-success border-success';
            break;
          case 'failed':
            cls += 'bg-primary border-primary';
            break;
          case 'generating':
            cls += 'border-border animate-pulse';
            break;
          default:
            cls += 'border-border';
        }
        return <div key={section.id} className={cls} />;
      })}
    </div>
  );
}
